import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';
import { environment } from '@env';
import { ErrorHandlerService } from './response-utils.service';
import { IdentityProvider } from '@components/customer';
import { catchError } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class IdentityProviderService {
  private http = inject(HttpClient);
  private errorHandler = inject(ErrorHandlerService);

  private IDP_URL: string = environment.apiUrl + '/tenant/identity-provider';

  getIdp(customerKey: string) {
    const url = `${this.IDP_URL}/${customerKey}`;
    return this.http
      .get(url)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  createIdp(idp: IdentityProvider) {
    return this.http
      .post(this.IDP_URL, idp)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  updateIdp(idp: IdentityProvider) {
    const url = `${this.IDP_URL}/${idp.alias}`;
    return this.http
      .put(url, idp)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }

  testConnection(discoveryUrl: string) {
    const url = `${this.IDP_URL}/import-config`;
    const body = { discoveryUrl: discoveryUrl };
    return this.http
      .post(url, body)
      .pipe(catchError((error: HttpErrorResponse) => this.errorHandler.errorHandler(error)));
  }
}
